/* eslint camelcase: 0 */

export interface IQueryProps {
  total?: number
  page?: number
  skip?: number
  take?: number
  count?: number
  sort?: string[] | null
  desc?: (boolean | undefined)[]
  word?: string | null
  query?: string | null
}

export const EmptyQueryPropsFactory = (props?: Partial<IQueryProps>): IQueryProps => ({
  ...props
})
